$(function () {
  let isClick = false;

  if ("ontouchstart" in window || navigator.maxTouchPoints > 0) return;

  $(document).on("mousedown", function () {
    isClick = true;
  });

  $(document).on("mouseup", function () {
    setTimeout(() => {
      isClick = false;
    }, 0);
  });

  $(document).on("mouseout", function (e) {
    if (isClick) return;

    console.log("FZ*91!");
    var Cookie = $.cookie("mouseleavePP");

    if (e.target.tagName.toLowerCase() == "input") return;

    var vpWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );

    if (e.clientX >= vpWidth - 50) return;

    if (e.clientY >= 50) return;

    var from = e.relatedTarget || e.toElement;
    if (!from) {
      if (typeof Cookie == "undefined") {
        $.cookie("mouseleavePP", 1, { expires: 1 });
        $("#popap-exit").modal();
      }
    }
  });


  $('body').on('submit','.popup-exit-js-validate-form', function (e) {
    if (e.isDefaultPrevented()) {
      // handle the invalid form...
    } else {

      $.ajax({
        type: "POST",
        url: $('.popup-exit-js-validate-form').attr('action'),
        data: $('.popup-exit-js-validate-form').serialize(),
        dataType: 'json',
        success: function(data){

          if(data.status == "success"){

            $('.popup-exit-js-validate-form .msg-success').removeClass('hidden');
            $('.popup-exit-js-validate-form input:not(.popup-exit-js-validate-form--send)').val("");
            $('.popup-exit-js-validate-form textarea').val("");
            

            location.href = "index.php?dir=site&page=forms&op=complete&cs=5022"; 
            setTimeout(function() {

              $('.popup-exit-js-validate-form .msg-success').addClass('hidden');
              $('#popap-exit').modal('hide');

            }, 2000);
          }else{
          }
        }
      });
    }
    return false;
  });

});
